module.exports = __webpack_public_path__ + "img/img-1.3b4f7621.png";